module.exports = "/lucky-balls/img/regular_game/header_maxbet.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/regular_game/header_maxbet.png
// module id = 1146
// module chunks = 0